function DekapostInsurance() {
  return (
    <li>
      <span>در سرویس دهنده </span>
      <span className="fs-5 fw-bold">دکاپست</span>
      <span> برای مرسولات از نوع پاکت، حداکثر ارزش کالا </span>
      <span>20,000,000 ریال</span>
      <span> می‌باشد</span>
    </li>
  );
}
export default DekapostInsurance;
